/******************************************************************************************
 *	Pre-Login Router State Service
 *******************************************************************************************
 *
 * Remembers requested state and state params before login in order to restore after successful login.
 *
 */
(function() {
  

  angular.module('rcServices.preLoginRouterState', []).service(
    'PreLoginRouterState',
    /* @ngInject */
    function(STORAGE_AVAILABLE, SessionStorage) {
      var name = null;
      var params = null;

      if (STORAGE_AVAILABLE) {
        var PRE_LOGIN_STATE_STORAGE_KEY = 'PreLoginState';

        //Try to recover state from previous session.
        var sessionData = SessionStorage.get(PRE_LOGIN_STATE_STORAGE_KEY);
        if (sessionData) {
          name = sessionData.name;
          params = sessionData.params;

          //One time only
          SessionStorage.remove(PRE_LOGIN_STATE_STORAGE_KEY);
        }
      }

      this.set = function(newName, newParams) {
        name = newName;
        params = newParams;

        //Save to session storage in case a redirect is triggered by the login flow
        SessionStorage.set(PRE_LOGIN_STATE_STORAGE_KEY, {
          name: name,
          params: params
        });
      };

      this.getName = function() {
        return name;
      };

      this.getParams = function() {
        return params;
      };

      this.clear = function() {
        name = null;
        params = null;

        SessionStorage.remove(PRE_LOGIN_STATE_STORAGE_KEY);
      };
    }
  );
})();
